import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { WellWaterSystemsMetricsInitialState } from '../wellWaterSystemMetrics.slice'
import { IWellWaterSystemsMetrics, RequestConfig } from '../../../../types';

export const fetchWellWaterSystemMetricsAsync = createAsyncThunk(
  'metrics/fetcWellMetrics',
  async ({ options }: { options?: RequestConfig },
    { rejectWithValue },) => {
    try {
      const response = await EpaApi.fetchWellWaterSystemsMetrics(options);
      return (response as AxiosResponse<any>).data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const fetchWellWaterSystemMetricsAsyncBuilder = (
  builder: ActionReducerMapBuilder<WellWaterSystemsMetricsInitialState>
) => {
  builder.addCase(fetchWellWaterSystemMetricsAsync.pending, (state) => {
    state.loading = true;
    state.success = false;
    state.error = '';
  });

  builder.addCase(
    fetchWellWaterSystemMetricsAsync.fulfilled,
    (state, action: PayloadAction<IWellWaterSystemsMetrics>) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload;
    }
  );

  builder.addCase(
    fetchWellWaterSystemMetricsAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    }
  );
};